var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c("el-header", { staticClass: "header" }, [_c("HeaderComponent")], 1),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c("SideBarComponent"),
          _vm._v(" "),
          _c(
            "el-main",
            { staticClass: "main" },
            [
              _c("SubTitleComponent", {
                attrs: { title: _vm.title, type: "" }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "box" },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.customerData.filter(function(data) {
                          return (
                            !_vm.searchValue ||
                            data.name
                              .toLowerCase()
                              .includes(_vm.searchValue.toLowerCase())
                          )
                        }),
                        stripe: ""
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "客户名称", prop: "client_name" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "客户类型", prop: "industry_type" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { align: "right" },
                        scopedSlots: _vm._u([
                          {
                            key: "header",
                            fn: function(scope) {
                              return [
                                _c("el-input", {
                                  attrs: { placeholder: "输入关键字搜索" },
                                  model: {
                                    value: _vm.searchValue,
                                    callback: function($$v) {
                                      _vm.searchValue = $$v
                                    },
                                    expression: "searchValue"
                                  }
                                })
                              ]
                            }
                          },
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.toDetail(
                                          scope.$index,
                                          scope.row
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("查看详情")]
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64f011ef", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64f011ef","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/CustomerHistory/Index.vue
// module id = null
// module chunks = 